import Products from './Products';
import '../output.css';

function Body(){
    return(
        <Products />
    )
}

export default Body;